namespace RedBullMOBILE360.Sms {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.Sms.WhiteListGrid')
    export class WhiteListGrid extends Serenity.EntityGrid<WhiteListRow, any> {
        protected getColumnsKey() { return WhiteListColumns.columnsKey; }
        protected getDialogType() { return WhiteListDialog; }
        protected getIdProperty() { return WhiteListRow.idProperty; }
        protected getInsertPermission() { return WhiteListRow.insertPermission; }
        protected getLocalTextPrefix() { return WhiteListRow.localTextPrefix; }
        protected getService() { return WhiteListService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }

        protected getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            //if (!Q.Authorization.userDefinition.IsAdmin)

            if (!Q.Authorization.hasPermission("Sms:AddWhitelist")) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            } else {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
                buttons.push({
                    title: 'Import From Excel',
                    cssClass: 'import-button',
                    onClick: () => {
                        var dialog = new WhitelistImportDialog();
                        dialog.dialogOpen();
                    }
                });
            }

            return buttons;
        }

    }
}